export function applyPixelRatioToCanvas(
  canvas: HTMLCanvasElement,
  w: number,
  h: number
): void {
  const PIXEL_RATIO = window.devicePixelRatio || 1;

  canvas.width = w * PIXEL_RATIO;
  canvas.height = h * PIXEL_RATIO;
  canvas.style.width = w + 'px';
  canvas.style.height = h + 'px';

  const ctx = canvas.getContext('2d');

  ctx?.setTransform(PIXEL_RATIO, 0, 0, PIXEL_RATIO, 0, 0);
  // Clear canvas to avoid scaling artifacts
  ctx?.clearRect(0, 0, canvas.width, canvas.height);
}
